import { useEffect } from 'react';

/**
 * open の間、document の Esc を capture 段階で受けて onClose を呼び、伝播を止める。
 * バナーレイアウトのモーダル (BannerLayoutEditorModal) も document の Esc で閉じるため、モーダルの中から開く
 * ポップオーバー (背景の分割・テンプレート名) は Esc で自分だけ閉じたい (Popover 自身の Esc 処理も同じ document のバブル段階)。
 */
export function useEscapeCapture(open: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      onClose();
    };
    document.addEventListener('keydown', onKeyDown, true);
    return () => document.removeEventListener('keydown', onKeyDown, true);
  }, [open, onClose]);
}
